import cookie from 'react-cookies';
import { CookieDataType, CookieDataExtendType } from './type.d';

export const signupCookie = ({ entry_name, sector_name, entry_position, page_url = '', skip = false }: CookieDataExtendType) => {
    if (typeof window === 'undefined') return;
    const { href, hostname } = window.location;
    const source_channel = 'Website';
    const obj: CookieDataType = {
        page_url: page_url || href,
        source_channel,
    };
    if (entry_name) {
        obj.entry_name = entry_name;
    }
    if (sector_name) {
        obj.sector_name = sector_name;
    }
    if (entry_position) {
        obj.entry_position = entry_position;
    }
    if (skip) {
        obj.skip = skip;
    }
    const arr = window.location.pathname.split('/');
    const locale = arr?.length >= 1 ? arr[1] : 'us';
    cookie.remove('signup_info', {
        domain: hostname.endsWith('.ecoflow.com') ? '.ecoflow.com' : hostname,
        path: `/${locale}`,
    });
    cookie.save('signup_info', obj, {
        domain: hostname.endsWith('.ecoflow.com') ? '.ecoflow.com' : hostname,
        path: `/${locale}`,
        expires: new Date(Date.now() + 3600 * 1000 * 24 * 7),
    });
    return obj;
};
